module.exports = __webpack_public_path__ + "img/9788971996522.1ea69e13.jpg";